import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { CheckboxField } from "../../../components/FormComponents/CheckboxField";
import { ITheme } from "../../../utils/theme";
import { IEmployeeInfo, IPaidPersonalLeaveRequestData } from "../PaidPersonalLeaveRequestData";

interface IConfirmationProps {
  data: IPaidPersonalLeaveRequestData;
  onChangeField: <K extends keyof IEmployeeInfo>(
    label: K,
    value: IEmployeeInfo[K]
  ) => void;
  error: Record<string, JSX.Element | string>;
  blurredFields: Partial<Record<keyof IEmployeeInfo, boolean>>
}

export const Confirmation: React.FC<IConfirmationProps> = ({
  data,
  onChangeField,
  error,
  blurredFields
}) => (
  <Box sx={{ p: { xs: 0, md: 2 } }}>
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ p: 0, mt: 2 }}>
        <CheckboxField
          label={<>
            <Typography sx={{ color: (theme: ITheme) => theme.palette.corporateBlue, mb: 1 }}>I certify that I have read and understood the terms outlined in this document.</Typography>
            <Typography sx={{ color: (theme: ITheme) => theme.palette.corporateBlue }}>I confirm that the information in this form is correct and that I meet the necessary requirements to be eligible for the Personal leave.  I understand that misrepresenting any information on this form is an act of dishonesty and fraud that may lead to serious discipline.</Typography>
          </>}
          fieldKey="certifyStatus"
          value={data?.employeeInfo.certifyStatus || false}
          onChange={(key, value) => onChangeField('certifyStatus', value)}
          error={blurredFields.certifyStatus ? error.certifyStatus : ''}
        />
      </Grid>
    </Grid>
  </Box>
)
